import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountGroup, AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { take } from 'rxjs/operators';
import { ActionListsApiService, ActionListsStoreService } from '../action-lists';
import { CreateListDialog } from '../action-lists/actions';
import { AddToListDialogComponent } from '../manage_accounts/dialogs/add-to-list-dialog.component';

@Component({
  template: '',
})
export class AccountAddToListComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AddToListDialogComponent>,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private accountGroupService: AccountGroupService,
    private readonly dialog: MatDialog,
    private actionListsApiService: ActionListsApiService,
    private actionListsStoreService: ActionListsStoreService,
  ) {}

  ngOnInit(): void {
    this.actionListsStoreService.initializeStore(1000);
    this.accountGroupService
      .get(this.route.snapshot.params.accountGroupId, new ProjectionFilter({ napData: true }))
      .pipe(take(1))
      .subscribe((accountGroup) => {
        this.openAddToListDialog(accountGroup);
      });
  }

  private showCreateListDialogAndAddAccount(accountGroup: AccountGroup): void {
    this.dialog.closeAll();
    const createDialog = this.dialog.open(CreateListDialog, {
      width: '620px',
    });
    createDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe((listName) => {
        if (listName) {
          this.actionListsApiService.createActionList(listName).subscribe(() => {
            this.actionListsApiService.addAccountToActionList(listName, accountGroup.accountGroupId);
          });
        }
        this.router.navigate([{ outlets: { action: null } }]);
      });
  }

  private openAddToListDialog(accountGroup: AccountGroup): void {
    this.dialog.closeAll();
    const addToListDialogRef = this.dialog.open(AddToListDialogComponent, {
      width: '620px',
    });
    addToListDialogRef.componentInstance.accountGroup = accountGroup;
    addToListDialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result === false) {
          this.showCreateListDialogAndAddAccount(accountGroup);
        } else {
          this.router.navigate([{ outlets: { action: null } }]);
        }
      });
  }
}
